import { UserContext } from '@faceup/member'
import { useContext } from 'react'
import { useMotherId } from '../providers'

export const usePartner = () => {
  const { viewer } = useContext(UserContext)
  const { getMotherIdWithNull } = useMotherId()
  const isPartner = viewer?.isPartner === true
  const isPartnerAdministration = isPartner && !getMotherIdWithNull()

  return {
    isPartnerAdministration,
    isPartner,
    partnerId: viewer?.partner?.id ?? null,
  }
}
